import { render } from "./StayGuests.vue?vue&type=template&id=031ffbe1"
import script from "./StayGuests.vue?vue&type=script&lang=js"
export * from "./StayGuests.vue?vue&type=script&lang=js"

import "@/shared/css/guests.css?vue&type=style&index=0&lang=css&external"
import "./StayGuests.vue?vue&type=style&index=1&id=031ffbe1&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__